import { render, staticRenderFns } from "./headerFormulario.vue?vue&type=template&id=f1a1da08&scoped=true"
import script from "./headerFormulario.vue?vue&type=script&lang=js"
export * from "./headerFormulario.vue?vue&type=script&lang=js"
import style0 from "./headerFormulario.vue?vue&type=style&index=0&id=f1a1da08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a1da08",
  null
  
)

export default component.exports